import React, { useState } from 'react';
import { broadcastTypeToLabelMapper } from 'views/ChatBroadcastList/utils';
import { parseISO, format } from 'date-fns';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { DatesHelper } from 'utils/classes/DatesHelper';

function formatDateScheduling(dateScheduling, time) {
  const [year, month, day] = String(dateScheduling).split('T')[0].split('-');
  return `${day}/${month}/${year} - ${time}`;
}

const ModalTextWhats = ({ row }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const mensagens = {
    1: 'Transferir para fila',
    2: 'Encerrar na primeira resposta',
    3: 'Transferir para fila com primeira resposta',
    4: 'Transferir para a FlexIA',
    5: 'Encerrar logo após o envio da mensagem',
    6: 'Transferir para FlexIA com protocolo'
  };

  row.broadcastTypeOfClosingConversationOptionsModal =
    mensagens[row.typeBroadcastList];

  const dateCreate = row.created_at
    ? format(parseISO(row.created_at), 'dd/MM/yyyy')
    : '';

  const campaignType =
    broadcastTypeToLabelMapper[row.broadcastTypeOfClosingConversation];

  const queueName = row.queue_name;

  return (
    <>
      <Button
        color="success"
        size="sm"
        title="Open Modal"
        onClick={toggleModal}
        className="ml-3 "
      >
        <i className="fas fa-info-circle"></i>
      </Button>

      <Modal isOpen={modalIsOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Informações da Campanha Ativa Whatsapp
        </ModalHeader>
        <ModalBody>
          <p>
            <strong>Título: </strong>
            {row.title}
          </p>
          <p>
            <strong>Data de criação: </strong>
            {dateCreate}
          </p>
          <p>
            <strong>Data de Encerramento: </strong>
            {row.expiresIn
              ? DatesHelper.convertISOToBrazilianDateTimeFormat(
                  DatesHelper.applyHoursToISO(row.expiresIn, -3)
                )
              : ''}
          </p>
          <p>
            <strong>Fila: </strong>
            {queueName ? queueName : ''}
          </p>
          <p>
            <strong>Tipo: </strong>
            {campaignType ? campaignType : ''}
          </p>
          <p>
            <strong>Whatsapp: </strong>
            {row.sourcePhone}
          </p>
          <p>
            <strong>Status: </strong>
            {row.status}
          </p>
          <p>
            <strong>
              Campanha Automática: {row.isEnabledSchedule ? 'Sim' : 'Não'}
            </strong>
          </p>
          {row.processedRecords ? (
            <p>
              <strong>
                Progresso da importação: {row.processedRecords} de{' '}
                {row.numberOfRecords}
              </strong>
            </p>
          ) : null}

          {row.isEnabledSchedule && (
            <p>
              <strong>Data e Horário de disparo: </strong>
              {formatDateScheduling(
                row.sendingScheduleDate,
                row.sendingScheduleTime
              )}
            </p>
          )}
          <p>
            <strong>Mensagem Predefinida: </strong>
            <br></br>
            {row.message}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggleModal}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalTextWhats;
